import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import { LanguageProvider } from "./context/LanguageContext";
import { AuthProvider } from "./context/AuthContext";
import { Layout } from "./components/Layout";
import { Seo } from "./components/Seo";
import Home from "./pages/Home";
import Ask from "./pages/Ask";
import Vision from "./pages/Vision";
import Explore from "./pages/Explore";
import Projects from "./pages/Projects";
import ProjectWorkspace from "./pages/ProjectWorkspace";
import Property from "./pages/Property";
import PropertyDetail from "./pages/PropertyDetail";
import Services from "./pages/Services";
import Experiences from "./pages/Experiences";
import Business from "./pages/Business";
import DirectoryList from "./pages/DirectoryList";
import BusinessProfile from "./pages/BusinessProfile";
import Partners from "./pages/Partners";
import BrokerCMA from "./pages/BrokerCMA";
import BrokerDashboard from "./pages/BrokerDashboard";
import AdminPilots from "./pages/AdminPilots";
import Trust from "./pages/Trust";
import About from "./pages/About";
import Auth from "./pages/Auth";
import Dashboard from "./pages/Dashboard";
import Memory from "./pages/Memory";
import Legal from "./pages/Legal";
import NotFound from "./pages/NotFound";

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <LanguageProvider>
          <AuthProvider>
            <BrowserRouter>
              <Seo />
              <Layout>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/ask" element={<Ask />} />
                  <Route path="/vision" element={<Vision />} />
                  <Route path="/explore" element={<Explore />} />
                  <Route path="/projects" element={<Projects />} />
                  <Route path="/projects/:id" element={<ProjectWorkspace />} />
                  <Route path="/property" element={<Property />} />
                  <Route path="/property/:id" element={<PropertyDetail />} />
                  <Route path="/services" element={<Services />} />
                  <Route path="/experiences" element={<Experiences />} />
                  <Route path="/business" element={<Business />} />
                  <Route path="/restaurants" element={<DirectoryList key="restaurants" section="restaurants" />} />
                  <Route path="/restaurants/:slug" element={<BusinessProfile section="restaurants" />} />
                  <Route path="/shopping" element={<DirectoryList key="shopping" section="shopping" />} />
                  <Route path="/shopping/:slug" element={<BusinessProfile section="shopping" />} />
                  <Route path="/directory" element={<DirectoryList key="directory" section="directory" />} />
                  <Route path="/directory/:slug" element={<BusinessProfile section="directory" />} />
                  <Route path="/partners" element={<Partners />} />
                  <Route path="/partners/broker" element={<BrokerCMA />} />
                  <Route path="/partners/broker/dashboard" element={<BrokerDashboard />} />
                  <Route path="/admin/pilots" element={<AdminPilots />} />
                  <Route path="/trust" element={<Trust />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/auth" element={<Auth />} />
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/memory" element={<Memory />} />
                  <Route path="/privacy" element={<Legal kind="privacy" />} />
                  <Route path="/terms" element={<Legal kind="terms" />} />
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </Layout>
            </BrowserRouter>
            <Toaster position="top-right" theme="dark" richColors />
          </AuthProvider>
        </LanguageProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
